import { render, staticRenderFns } from "./DuplicateTrainingItemModal.vue?vue&type=template&id=52e68f7c&"
import script from "./DuplicateTrainingItemModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateTrainingItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports